// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___CS9Y7 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}
.styles__container___CS9Y7 section {
  margin-bottom: 45px;
}
.styles__container___CS9Y7 {
  padding: 36px;
  background: #FFFFFF;
}
.styles__input___cjrpD {
  box-shadow: none;
  border: none;
  background: transparent;
  border-bottom: 1px solid black;
  display: block;
  text-align: right;
  width: 100px;
}
.styles__flexIt____Gpa7 {
  display: flex;
  align-items: center;
}
.styles__flexColumn___T7a4u {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.styles__textRight___sootR {
  text-align: right;
}
.styles__flexEnd___mA1cL {
  display: flex;
  justify-content: flex-end;
}
.styles__button___k0Mne {
  width: 218px;
  margin-top: 20px;
}
.styles__productTitle___n6OvI {
  font-weight: 400;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline;
}
.styles__section___ts1mN {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  padding: 36px;
  background: #FFFFFF;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}
.styles__section___ts1mN section {
  margin-bottom: 45px;
}
.styles__column___vKDo1 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (max-width: 991px) {
  .styles__column___vKDo1 {
    align-items: center;
  }
}
.styles__titleColumn___mYdsk {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.styles__title___SoOcc {
  align-items: flex-start;
}
.styles__price___wZ2iO {
  text-align: right;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
}
@media (max-width: 991px) {
  .styles__price___wZ2iO {
    align-items: flex-end;
  }
}
.styles__product___gO6RK {
  background-color: #EEEEEE;
  display: flex;
  flex-direction: row;
}
@media (max-width: 991px) {
  .styles__product___gO6RK {
    flex-direction: column;
  }
}
.styles__text___rFd8W h1 {
  margin-top: 0px;
}
.styles__alert___awE3z {
  text-align: left;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/layout.less","webpack://./src/components/components/Search/WheelBuilderConfirmation/styles.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ACDF;ADTA;EAYI,mBAAA;ACAJ;AAXA;EACE,aAAA;EACA,mBAAA;AAaF;AAVA;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAYF;AATA;EACE,aAAA;EACA,mBAAA;AAWF;AARA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAUF;AAPA;EACE,iBAAA;AASF;AANA;EACE,aAAA;EACA,yBAAA;AAQF;AALA;EACE,YAAA;EACA,gBAAA;AAOF;AAJA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;AAMF;AAHA;EDhDE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;ECNA,aAAA;EACA,mBAAA;EAiDA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAcF;AAnBA;EDrCI,mBAAA;AC2DJ;AAdA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAgBF;AAfE;EAAA;IACE,mBAAA;EAkBF;AACF;AAfA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAiBF;AAdA;EAEE,uBAAA;AAgBF;AAbA;EAEE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAeF;AAdE;EAAA;IACE,qBAAA;EAiBF;AACF;AAdA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AAgBF;AAfE;EAAA;IACE,sBAAA;EAkBF;AACF;AAfA;EAEI,eAAA;AAgBJ;AAZA;EACE,gBAAA;EACA,gBAAA;AAcF","sourcesContent":["@import './variables.less';\n\n.container {\n  max-width: 1140px !important;\n  margin-top: 20px;\n  margin-bottom: 15px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: @eon-box-shadow;\n  transition: @eon-transition-default;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  section {\n    margin-bottom: 45px;\n  }\n}\n","@import '../../../../shared/layout.less';\n@import '../../../../shared/variables.less';\n\n.container {\n  padding: 36px;\n  background: #FFFFFF;\n}\n\n.input {\n  box-shadow: none;\n  border: none;\n  background: transparent;\n  border-bottom: 1px solid black;\n  display: block;\n  text-align: right;\n  width: 100px;\n}\n\n.flexIt {\n  display: flex;\n  align-items: center;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.textRight {\n  text-align: right;\n}\n\n.flexEnd {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  width: 218px;\n  margin-top: 20px;\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: underline;\n}\n\n.section {\n  composes: container;\n  .container();\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 10px;\n}\n\n.column {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  @media (max-width: @screen-sm-max) {\n    align-items: center;\n  }\n}\n\n.titleColumn {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.title {\n  composes: flexColumn;\n  align-items: flex-start;\n}\n\n.price {\n  composes: column;\n  text-align: right;\n  font-weight: bold;\n  font-size: 18px;\n  align-items: center;\n  @media (max-width: @screen-sm-max) {\n    align-items: flex-end;\n  }\n}\n\n.product {\n  background-color: #EEEEEE;\n  display: flex;\n  flex-direction: row;\n  @media (max-width: @screen-sm-max) {\n    flex-direction: column;\n  }\n}\n\n.text {\n  h1 {\n    margin-top: 0px;\n  }\n}\n\n.alert {\n  text-align: left;\n  margin-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___CS9Y7`,
	"input": `styles__input___cjrpD`,
	"flexIt": `styles__flexIt____Gpa7`,
	"flexColumn": `styles__flexColumn___T7a4u`,
	"textRight": `styles__textRight___sootR`,
	"flexEnd": `styles__flexEnd___mA1cL`,
	"button": `styles__button___k0Mne`,
	"productTitle": `styles__productTitle___n6OvI`,
	"section": `styles__section___ts1mN styles__container___CS9Y7`,
	"column": `styles__column___vKDo1`,
	"titleColumn": `styles__titleColumn___mYdsk`,
	"title": `styles__title___SoOcc styles__flexColumn___T7a4u`,
	"price": `styles__price___wZ2iO styles__column___vKDo1`,
	"product": `styles__product___gO6RK`,
	"text": `styles__text___rFd8W`,
	"alert": `styles__alert___awE3z`
};
export default ___CSS_LOADER_EXPORT___;
